/* Medicus — personalised cap form (19 September 2026)

   Four small jobs on the YMQ option form. None of them selects, deselects or
   renames an option on its own; the customer's choices, the line-item
   properties and the "---" sku string are exactly what YMQ produces.

   1. TAGS for the stylesheet (assets/mc-personalised.css): colour groups get
      .mc-colours, a four-column grid and a "Show all N colours" button (phone
      only; rebuilt 16 Oct 2026, see collapse()); the 150px-tile groups get
      .mc-tiles.
   2. ORDER: each "#N Embroidery Text Font" box is moved to sit after the text
      lines it applies to (just before "#N ... Embroidery Text Colours"), so
      the customer types their name before they choose a font. Re-applied
      when YMQ re-renders.
   3. VINYL TEXT GUARD: with "Add Text Only #N As Vinyl Transfer" ticked, add
      to cart is held until the design tool has text (or a file is uploaded in
      the YMQ upload box). Before this, the £2.50 vinyl option went through
      with no text at all whenever no font tile had been tapped.
   4. CHANGE OPTIONS: opened from the cart with ?mc-edit=<line key>, the
      saved choices are re-applied to the form, and when the customer adds
      the cap again the old line is removed from the cart.

   Remove the render line in layout/theme.liquid and all four are gone. */
(function () {
  'use strict';
  if (window.__mcPersonalised) return;
  window.__mcPersonalised = true;

  var raf = window.requestAnimationFrame || function (f) { setTimeout(f, 16); };
  function boxes() { return Array.prototype.slice.call(document.querySelectorAll('.ymq-options-box[ymq-option-label]')); }
  function label(b) { return b.getAttribute('ymq-option-label') || ''; }
  function shown(el) { return !!(el && (el.offsetWidth || el.offsetHeight)); }

  /* ---------------------------------------------------------------- 1. tags */
  var COLOURS = [/^Scrub Cap Main Colour/i, /Embroidery Text Colours/i];
  var TILES = [/Embroidery Text Font/i, /^Tap One To Add Custom Embroidery/i, /^Tap To Add An Image/i, /Embroidery Text Placement/i, /^Add 2nd Embroidered Text/i];
  var TILES3 = [/^Select Which Advanced Customisations/i];

  function tag() {
    boxes().forEach(function (b) {
      var info = b.querySelector('.ymq-option-value-info');
      if (!info) return;
      var l = label(b);
      if (TILES.some(function (re) { return re.test(l); })) info.classList.add('mc-tiles');
      if (TILES3.some(function (re) { return re.test(l); })) { info.classList.add('mc-tiles', 'mc-tiles--3'); }
      if (COLOURS.some(function (re) { return re.test(l); })) {
        info.classList.add('mc-colours');
        if (!info.hasAttribute('data-mc-collapse')) collapse(info);
      }
    });
  }

  /* Colour groups (rebuilt 16 Oct 2026). On a phone the group is a real
     four-column grid (assets/mc-personalised.css, .mc-colours-grid), and
     beyond ten colours only the first eight show until "Show all N colours"
     is tapped. The chosen colour always stays in view: if it sits past the
     eighth, it takes the eighth slot.

     What changed from 19 Sept, and why:
     - Folding is done here with our own .mc-fold class, counted over the
       values that are actually showing. The old nth-child(n + 9) rule
       counted values YMQ had already hidden, so fewer than eight showed.
     - "Show all colours" did nothing for most colours: the old open rule
       (.mc-open ... display:flex) lost on specificity to the fold rule
       (:nth-child(n + 9):not(.mc-keep)), so tapping it only revealed the
       hidden "Order Sample Box Instead" value. Opening now just removes
       .mc-fold, and YMQ's own conditional hiding is left alone.
     - The grid replaces flex widths, so a wider selected tile or a different
       sized image (the "Get Sample Swatches" tile) can no longer knock a row
       out of line.
     - Re-counted after every change on the page, because a fit or size
       choice can change which colours YMQ offers. */
  var COLLAPSE_SHOW = 8;
  var COLLAPSE_MIN = 10;
  var groups = [];

  function itemsOf(grid) {
    return Array.prototype.filter.call(grid.children, function (el) {
      return el.classList && el.classList.contains('ymq-option-value-item');
    });
  }
  function isSampleTile(it) {
    var inp = it.querySelector('input');
    return /sample/i.test((inp && inp.value) || it.textContent || '');
  }

  function collapse(info) {
    var first = info.querySelector('.ymq-option-value-item');
    if (!first || !first.parentElement) return;
    info.setAttribute('data-mc-collapse', '');
    var grid = first.parentElement;
    grid.classList.add('mc-colours-grid');
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'mc-more';
    btn.hidden = true;
    var g = { info: info, grid: grid, btn: btn, open: false };
    btn.addEventListener('click', function () {
      g.open = !g.open;
      paint(g);
      if (!g.open) info.scrollIntoView({ block: 'nearest' });
    });
    info.after(btn);
    groups.push(g);
    paint(g);
  }

  function paint(g) {
    var items = itemsOf(g.grid);
    var i;
    for (i = 0; i < items.length; i++) items[i].classList.remove('mc-fold');
    var live = items.filter(function (it) {
      return !it.classList.contains('ymq-option-condition-hide') && getComputedStyle(it).display !== 'none';
    });
    var colours = live.filter(function (it) { return !isSampleTile(it); }).length;
    var foldable = colours > COLLAPSE_MIN;
    g.info.classList.toggle('mc-collapse', foldable);
    g.info.classList.toggle('mc-open', foldable && g.open);
    if (g.btn.hidden === foldable) g.btn.hidden = !foldable;
    if (!foldable) return;
    if (!g.open) {
      var show = live.slice(0, COLLAPSE_SHOW);
      var picked = live.filter(function (it) { return !!it.querySelector('input:checked'); })[0];
      if (picked && show.indexOf(picked) === -1) show = live.slice(0, COLLAPSE_SHOW - 1).concat(picked);
      for (i = 0; i < live.length; i++) if (show.indexOf(live[i]) === -1) live[i].classList.add('mc-fold');
    }
    var text = g.open ? 'Show fewer colours' : 'Show all ' + colours + ' colours';
    if (g.btn.textContent !== text) g.btn.textContent = text;
    g.btn.setAttribute('aria-expanded', g.open ? 'true' : 'false');
  }

  var repaintTimer = null;
  function repaintAll() {
    clearTimeout(repaintTimer);
    repaintTimer = setTimeout(function () {
      groups = groups.filter(function (g) {
        if (!g.grid.isConnected) { g.btn.remove(); return false; }
        paint(g);
        return true;
      });
    }, 120);
  }
  document.addEventListener('change', repaintAll, true);

  /* --------------------------------------------------------------- 2. order */
  function orderFonts() {
    var bs = boxes();
    bs.forEach(function (fb) {
      var m = label(fb).match(/^#(\d) Embroidery Text Font/);
      if (!m) return;
      var re = new RegExp('^#' + m[1] + ' (Main )?Embroidery Text Colours');
      var target = bs.filter(function (b) { return re.test(label(b)); })[0];
      if (target && fb.parentNode === target.parentNode && fb.nextElementSibling !== target) target.before(fb);
    });
  }

  /* ---------------------------------------------------- 3. vinyl text guard */
  function isAtc(el) {
    if (!el || !el.closest) return false;
    if (el.closest('.mc-vinyl-error')) return false;
    return !!(el.closest('.add-to-cart-button') || el.closest('button[name="add"]') || el.closest('add-to-cart-component'));
  }
  function vinylTicked(n) {
    var sel = n === 1 ? 'input:checked[value^="Add Text Only #1 As Vinyl"]' : 'input:checked[value^="Add Another Vinyl Transfer"]';
    var inp = document.querySelector('.ymq-options-box ' + sel);
    return !!(inp && shown(inp.closest('.ymq-options-box')));
  }
  function vinylHasText(n) {
    var lines = document.querySelectorAll('input[data-font-picker="' + n + '"]');
    for (var i = 0; i < lines.length; i++) {
      if (/ Line \d\]$/.test(lines[i].name) && lines[i].value.trim()) return true;
    }
    return false;
  }
  function vinylHasFile(n) {
    var re = new RegExp('Vinyl Transfer Text #' + n);
    var box = boxes().filter(function (b) { return re.test(label(b)); })[0];
    if (!box) return false;
    if (box.querySelector('.ymq-has-file, .ymq-success-badge')) return true;
    var f = box.querySelector('input[type="file"]');
    return !!(f && f.files && f.files.length);
  }
  function vinylProblem() {
    for (var n = 1; n <= 2; n++) {
      if (vinylTicked(n) && !vinylHasText(n) && !vinylHasFile(n)) return n;
    }
    return 0;
  }
  function showVinylError(n) {
    var picker = document.getElementById('font-picker-' + n);
    var host = picker || boxes().filter(function (b) { return new RegExp('Vinyl Transfer Text #' + n).test(label(b)); })[0];
    if (!host) return;
    var msg = host.querySelector('.mc-vinyl-error');
    if (!msg) {
      msg = document.createElement('div');
      msg.className = 'mc-vinyl-error';
      msg.setAttribute('role', 'alert');
      msg.textContent = 'Type the text you want on the cap and tap a font, or upload your own design below, before adding to cart.';
      host.appendChild(msg);
    }
    msg.scrollIntoView({ behavior: 'smooth', block: 'center' });
    var first = picker && picker.querySelector('.font-picker__line-input');
    if (first) setTimeout(function () { try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); } }, 350);
  }
  function clearVinylError() {
    Array.prototype.forEach.call(document.querySelectorAll('.mc-vinyl-error'), function (m) { m.remove(); });
  }
  window.addEventListener('click', function (ev) {
    if (!isAtc(ev.target)) return;
    var n = vinylProblem();
    if (!n) { clearVinylError(); return; }
    ev.preventDefault();
    ev.stopPropagation();
    if (ev.stopImmediatePropagation) ev.stopImmediatePropagation();
    showVinylError(n);
  }, true);
  document.addEventListener('font-picker:change', function () { if (!vinylProblem()) clearVinylError(); });

  /* ----------------------------------------------------- 4. change options */
  var params = new URLSearchParams(location.search);
  var editKey = params.get('mc-edit');
  function baseName(name) { return String(name || '').replace(/-[a-z0-9]{5,8}$/, ''); }
  function clean(v) { return String(v == null ? '' : v).replace(/\(\+[^)]*\)/g, '').replace(/\s+/g, ' ').trim(); }

  function restore(item) {
    var props = item.properties || {};
    var pending = Object.keys(props).filter(function (k) {
      return k.charAt(0) !== '_' && k !== 'sku' && !/^Vinyl Text #\d/.test(k) && props[k] != null && String(props[k]).trim() !== '';
    });
    var rounds = 0;
    banner();
    (function step() {
      var progress = false;
      pending = pending.filter(function (k) {
        var want = clean(props[k]);
        var inputs = document.querySelectorAll('.ymq-options-box input, .ymq-options-box textarea, .ymq-options-box select');
        for (var i = 0; i < inputs.length; i++) {
          var inp = inputs[i];
          if (baseName(inp.name) !== k) continue;
          if (!shown(inp.closest('.ymq-options-box'))) continue;
          if (inp.type === 'radio' || inp.type === 'checkbox') {
            var have = clean(inp.value);
            if (have === want || (have && want.indexOf(have) === 0)) {
              if (!inp.checked) inp.click();
              progress = true;
              return false;
            }
            continue;
          }
          if (inp.type === 'file' || inp.type === 'hidden') return false;
          inp.value = props[k];
          inp.dispatchEvent(new Event('input', { bubbles: true }));
          inp.dispatchEvent(new Event('change', { bubbles: true }));
          progress = true;
          return false;
        }
        return true;
      });
      rounds++;
      if (pending.length && rounds < 14) setTimeout(step, progress ? 700 : 1200);
      else {
        window.__mcEditing = item.key;
        if (pending.length) console.warn('[mc-personalised] could not restore:', pending);
      }
    })();
  }

  function banner() {
    if (document.querySelector('.mc-edit-banner')) return;
    var first = document.querySelector('.ymq-options-box');
    if (!first) return;
    var el = document.createElement('div');
    el.className = 'mc-edit-banner';
    el.innerHTML = '<strong>Editing the cap in your basket.</strong> Your choices are filled in below. Change what you need and add it to cart again; the old one is swapped out for you.';
    first.before(el);
  }

  if (editKey) {
    var origFetch = window.fetch;
    window.fetch = function (u, o) {
      var url = typeof u === 'string' ? u : (u && u.url) || '';
      var p = origFetch.apply(this, arguments);
      if (!window.__mcEditing || url.indexOf('/cart/add') === -1) return p;
      var key = window.__mcEditing;
      return p.then(function (res) {
        if (!res || !res.ok) return res;
        window.__mcEditing = null;
        return origFetch('/cart/change.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        }).then(function () { return res; }, function () { return res; });
      });
    };
  }

  function startRestore() {
    if (!editKey) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var item = (cart.items || []).filter(function (i) { return i.key === editKey; })[0];
      if (item) restore(item);
    }).catch(function () {});
  }

  /* ------------------------------------------------------------ lifecycle */
  var timer = null;
  function apply() { tag(); orderFonts(); }
  function schedule() { clearTimeout(timer); timer = setTimeout(apply, 250); }

  function relevant(records) {
    for (var i = 0; i < records.length; i++) {
      var r = records[i];
      if (r.type !== 'childList') continue;
      for (var j = 0; j < r.addedNodes.length; j++) {
        var n = r.addedNodes[j];
        if (n.nodeType !== 1) continue;
        if (n.classList && n.classList.contains('ymq-options-box')) return true;
        if (n.querySelector && n.querySelector('.ymq-options-box')) return true;
      }
    }
    return false;
  }

  function boot() {
    apply();
    var mo = new MutationObserver(function (records) { if (relevant(records)) schedule(); });
    mo.observe(document.body, { childList: true, subtree: true });
    var tries = 0;
    (function waitForForm() {
      if (document.querySelector('.ymq-options-box')) { apply(); setTimeout(startRestore, 800); return; }
      if (++tries < 40) setTimeout(waitForForm, 250);
    })();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
